import { FeedbackResponse } from '../types/FeedbackResponse';
import { IFeedback } from '../interfaces/IFeedback';
import { apiPost } from '../common/apiTools';

export async function fetchAddFeedback(data: IFeedback): Promise<FeedbackResponse> {
  return apiPost<FeedbackResponse>({ url: '/support/api/feedback', body: data });
}
